import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import type { PropsWithChildren } from "react";
import * as React from "react";
import { DisabledStatusIcon } from "./DisabledStatusIcon";
import { GreenTickIcon } from "./GreenTickIcon";
import { PauseIcon } from "./PauseIcon";
type AuditStreamStatus = "active" | "paused" | "inactive";
interface AuditActionWithStatusProps {
    status: AuditStreamStatus;
}
export function AuditActionWithStatus({ status, children }: PropsWithChildren<AuditActionWithStatusProps>) {
    return (<div className={containerStyles}>
            {getStatusIcon(status)}
            {children}
        </div>);
}
const containerStyles = css({
    display: "flex",
    alignItems: "center",
    gap: space[4],
});
function getStatusIcon(status: AuditStreamStatus) {
    switch (status) {
        case "active":
            return <GreenTickIcon />;
        case "inactive":
            return <DisabledStatusIcon />;
        case "paused":
            return <PauseIcon />;
    }
}
